export const getContactPreferences = (settings = {}, userContactPreferences = []) =>
    userContactPreferences.reduce((memo, item) => {
        const { channel, type, preference } = item;
        const { [type]: settingsType = [] } = settings;
        const preferenceList = memo[type];

        switch (type) {
            case 'promotional':
                if (settingsType.includes(channel)) {
                    preferenceList.push({ type, channel, preference });
                }

                break;
            case 'account':
                if (settingsType.includes(channel)) {
                    preferenceList.push({ type, channel, preference: !preference });
                }

                break;
            case 'thirdParty':
                if (settingsType.includes(type)) {
                    preferenceList.push({ type, preference });
                }

                break;
            default:
                break;
        }

        return memo;
    }, {
        promotional: [],
        account: [],
        thirdParty: []
    });
